import React, { useState } from 'react';
import Button from '@/lib/Button';
import Modal from '@/lib/Modal';
import SecuredByRazorpay from '@/lib/SecuredByRazorpay';
import { verifyIncome } from '@/api/employer-verifivcation';

type ModalProp = {
  isOpen: boolean;
  data: {
    id: string;
    name: string;
    email: string;
  };
  onDismiss: () => void;
  onSuccess: (url: string) => void;
  onError: (err: unknown) => void;
};

const IncomeVerificationPopup = ({
  isOpen,
  onDismiss,
  onSuccess,
  data,
  onError,
}: ModalProp): JSX.Element => {
  const [loading, setIsLoading] = useState(false);

  const handleRedirect = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const resp = await verifyIncome(data);
      if (resp.url) {
        onSuccess(resp.url);
      }
    } catch (err: unknown) {
      onError(err);
    }
    setIsLoading(false);
  };

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <Modal.Body>
        <div className="d:w-1/2">
          <h2 className="font-tasa font-semibold text-on-grey-normal text-2xl mr-4">
            Income verification via Netbanking
          </h2>
          <p className="mt-2 mb-5 text-base text-on-grey-subtle">
            Salary account Netbanking credentials will be required to securely access your income
            statement. For this, we’ll redirect you to Perfios
          </p>
          <Button
            data-testid="verify-icnome"
            onClick={handleRedirect}
            isLoading={loading}
            loadingText="Taking you to Perfios"
          >
            Verify Income
          </Button>
          <SecuredByRazorpay />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default IncomeVerificationPopup;
